<template>
  <div class="top_fixed" @click="handleTopBroadcast">
    <div class="icon_help">
      <img src="../images/ic_laba.png" alt="" />
    </div>
    <div class="top_notice" aria-label="顶部广播">
      <div
        class="top_notice_track"
        :class="{ is_overflow: isOverflow }"
        ref="topNoticeTrackRef"
      >
        <span
          class="top_notice_item"
          :class="{ is_overflow: isOverflow }"
          ref="topNoticeItemRef"
          >{{ topText }}</span
        >
        <span
          class="top_notice_item"
          :class="{ is_overflow: isOverflow }"
          v-if="isOverflow"
          aria-hidden="true"
        >
          {{ topText }}
        </span>
      </div>
    </div>

    <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed"></WxOpenAppItm>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref, watch, defineAsyncComponent } from "vue";
const WxOpenAppItm = defineAsyncComponent(() =>
  import("@/components/WxOpenAppItm.vue").then(
    (module: any) => module.default || module
  )
);
import { appInfo } from "@eastmoney/mku";
import { storeToRefs } from "pinia";
import { useMainStore } from "@/pinia/main";
const store = useMainStore();
const { hasAuth } = storeToRefs(store);

const props = withDefaults(
  defineProps<{
    topText: string;
    configObj: Record<string, any>;
  }>(),
  {
    topText: "",
    configObj: () => ({}),
  }
);

const isOverflow = ref(false);
const topNoticeTrackRef = ref<HTMLElement | null>(null);
const topNoticeItemRef = ref<HTMLElement | null>(null);
const RIGHT_SAFE_GAP = 16;

const updateOverflow = () => {
  const trackEl = topNoticeTrackRef.value;
  const itemEl = topNoticeItemRef.value;
  const parentEl = trackEl?.parentElement;
  if (!trackEl || !itemEl || !parentEl) {
    isOverflow.value = false;
    return;
  }
  isOverflow.value =
    itemEl.scrollWidth + RIGHT_SAFE_GAP >= parentEl.clientWidth;
};

const handleTopBroadcast = () => { 
  const noticeConfig = props.configObj?.noticeConfig || [];
  console.log("🚀 ~ handleTopBroadcast ~ noticeConfig:", noticeConfig);
  const iosLink = noticeConfig[0]?.iosLink || "";
  const androidLink = noticeConfig[0]?.androidLink || "";
  if (iosLink && androidLink) {
    appInfo.inApp(
      () => {
        // 在app中
        if (appInfo.isIOS) {
          window.location.href = iosLink;
        } else {
          window.location.href = androidLink;
        }
      },
      () => {
        // 在app外
        linkAppMed();
      }
    );
  }
};
/**
 * 跳转承接页
 */
const linkAppMed = () => {
  window.linkAppMed();
};
const handleResize = () => {
  updateOverflow();
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
  nextTick(() => {
    updateOverflow();
  });
});

watch(
  () => props.topText,
  () => {
    nextTick(() => {
      updateOverflow();
    });
  }
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style scoped lang="scss">
.top_fixed {
  width: 100%;
  position: relative;
  height: 0.72rem;
  background: rgba(255, 85, 0, 0.1);
  font-size: 0.26rem;
  color: #ff5500;
  display: flex;
  align-items: center;
  z-index: 20;

  .icon_help {
    margin-left: 0.24rem;
    margin-right: 0.16rem;
    width: 0.32rem;
    height: 0.28rem;
    font-size: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .top_notice {
    position: relative;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .top_notice_track {
    display: inline-flex;
    align-items: center;
    width: max-content;
    will-change: transform;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;

    &.is_overflow {
      animation: top_notice_scroll 8s linear infinite;
    }
  }

  .top_notice_item {
    display: inline-block;
    padding-right: 0;
    white-space: nowrap;
    flex-shrink: 0;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;

    &.is_overflow {
      padding-right: 1.2rem;
    }
  }

  @keyframes top_notice_scroll {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-50%);
    }
  }
}
</style>
